import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const RestaurantManagerLink = ({ withUpsellingRedirect }) => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to={
          withUpsellingRedirect
            ? '/dashboard/upselling/restaurantManager'
            : '/dashboard/building-dashboard/restaurant-manager'
        }
      >
        <span>
          {t('navbar:upsellingLinks.restaurantManager')}
          <NavigationLabel type={NAVIGATION_LABELS.BETA} locked={withUpsellingRedirect} />
        </span>
      </NavLink>
    </div>
  )
}

RestaurantManagerLink.propTypes = {
  withUpsellingRedirect: PropTypes.bool,
}

export default RestaurantManagerLink
